import { RouteConfig } from "vue-router";

export const RUploadDocuments: RouteConfig = {
  path: "upload/:directoryId(\\d+)/:fileType",
  component: () =>
    import(
      /* webpackChunkName: "upload-documents" */
      "./VUploadDocuments.vue"
    ),
  meta: {
    hide: true,
    version: 2,
  },
};
